module.exports = __webpack_public_path__ + "img/5.7186c93e.jpg";